import { SITE } from "../constants/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <img src={SITE.logo} alt="Sugee Group" className="h-11 w-auto mb-2" />
          <p className="text-[10px] uppercase tracking-[0.4em] text-primary mb-6">Lake District · Thane West</p>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Est. 1986 — 32 successful projects and 16 million+ sq. ft. delivered across Mumbai.
          </p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.35em] text-muted-foreground mb-6">Project</p>
          <ul className="text-sm text-foreground/80 space-y-3">
            <li>35 Grade A+ office floors + retail & recreation</li>
            <li>52-acre integrated mixed-use district</li>
            <li>Offices from ₹2.64 Cr* onwards</li>
            <li>Possession: as per RERA timeline</li>
            <li>Architect: Padma Bhushan Hafeez Contractor</li>
          </ul>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.35em] text-muted-foreground mb-6">Launch Desk</p>
          <ul className="text-sm text-foreground/80 space-y-3">
            <li>{SITE.phoneDisplay}</li>
            <li>Opp. Korum Mall, near Cadbury Junction, Thane West</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60">
        <div className="max-w-screen-2xl mx-auto px-6 py-8">
          <p className="text-[11px] text-muted-foreground/70 leading-relaxed mb-4">
            Disclaimer: This project is MahaRERA Registered — PC1331012601435. This project is marketed and promoted
            by a Registered Channel Partner, Reg No: A51800013649 — Parin Majithia, Channel Partner. All prices,
            plans and images are indicative and subject to change.
          </p>
          <div className="flex flex-col sm:flex-row justify-between gap-3 text-[11px] text-muted-foreground">
            <span>© 2026 Parin Majithia — Channel Partner. All rights reserved.</span>
            <span>MahaRERA: PC1331012601435</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
